// vat-prices.js
(function () {
  // === VAT map: EU + Norway (standard rates). DE, GB, NO are *excluded from math* (Shopify handles them) ===
  const TAX_RATES = {
    AT: 0.20, BE: 0.21, BG: 0.20, HR: 0.25, CY: 0.19, CZ: 0.21, DK: 0.25,
    EE: 0.24, // Estonia
    FI: 0.255, FR: 0.20, GR: 0.24, HU: 0.27, IE: 0.23, IT: 0.22,
    LV: 0.21, LT: 0.21, LU: 0.17, MT: 0.18, NL: 0.21, PL: 0.23, PT: 0.23,
    RO: 0.19, SK: 0.23, SI: 0.22, ES: 0.21, SE: 0.25
    // NO/GB/DE intentionally not listed here so we don't add anything on top
  };
  const SPECIAL_INCLUDED = new Set(['GB', 'NO', 'DE']); // Show "Including VAT" note, but do NOT change price.

  // === helpers (globals set in theme.liquid) ===
  function getCountryISO() { return window.__LOC_COUNTRY || 'NO'; }
  function getMoneyFormat(override) { return override || window.__MONEY_FORMAT || '${{amount}}'; }
  function getCurrency(override) { return override || window.__CURRENCY || 'EUR'; }
  function getDecimals(override) { return Number(override ?? window.__CURRENCY_DECIMALS ?? 2); }

  function formatMoney(cents, opts = {}) {
    const fmt = getMoneyFormat(opts.moneyFormat);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(Math.round(cents), fmt);
    }
    return (Math.round(cents) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: getCurrency(opts.currency),
      minimumFractionDigits: getDecimals(opts.decimals),
      maximumFractionDigits: getDecimals(opts.decimals)
    });
  }

  // ===== PRODUCT PAGE =====
  function applyVATToProduct(countryISO) {
    const mainPrice =
      document.querySelector('.price-item--regular') ||
      document.querySelector('[data-price]');
    const base = Number(window.__BASE_PRICE_CENTS || 0);
    if (!mainPrice || !base) { setProductNote(countryISO); return; }

    const rate = TAX_RATES[countryISO] ?? 0;
    // If country is in SPECIAL_INCLUDED, or rate == 0, we don't alter the number.
    if (rate > 0) {
      const withTax = Math.round(base * (1 + rate));
      mainPrice.textContent = formatMoney(withTax);
    }
    setProductNote(countryISO);
  }

  function setProductNote(countryISO) {
    const note = document.getElementById('js-vat-note');
    if (!note) return;

    const rate = TAX_RATES[countryISO] ?? 0;
    if (SPECIAL_INCLUDED.has(countryISO) || rate > 0) {
      // GB/NO/DE OR any other EU country in TAX_RATES → show "Including VAT"
      note.style.display = 'inline';
      note.textContent = 'Including VAT';
    } else {
      // Everyone else (e.g., US/CA/AU etc.)
      note.style.display = 'inline';
      note.innerHTML = 'Tax not included. Orders shipped internationally may be subject to import duties. <a href="https://www.arcticedge.eu/pages/shipping">Learn more</a>';
    }
  }

  // ===== CARDS (home, collections, search, “all products”) =====
  function applyVATToCards(countryISO) {
    const nodes = document.querySelectorAll('[data-vat-price]');
    if (!nodes.length) return;
    const rate = TAX_RATES[countryISO] ?? 0;

    nodes.forEach(node => {
      const base = Number(node.dataset.basePrice || 0);
      if (!base) return;

      const moneyFormat = node.dataset.moneyFormat;
      const currency = node.dataset.currency;
      const decimals = Number(node.dataset.decimals || 2);
      const priceEl = node.querySelector('.price-item--regular') || node;

      if (rate > 0) {
        const withTax = Math.round(base * (1 + rate));
        if (priceEl) priceEl.textContent = formatMoney(withTax, { moneyFormat, currency, decimals });
      } // else: leave as-is (GB/NO/DE and rest of world)
    });
  }

  function applyEverywhere() {
    const country = getCountryISO();
    applyVATToProduct(country);
    applyVATToCards(country);
  }

  // ===== EVENTS =====
  document.addEventListener('DOMContentLoaded', function () {
    applyEverywhere();

    // Country selector changed
    document.addEventListener('change', (e) => {
      const sel = e.target.closest('select[name="country_code"]');
      if (sel) applyEverywhere();
    });

    // Variant changed on product page (Dawn emits this)
    document.addEventListener('variant:change', (e) => {
      const v = e?.detail?.variant;
      if (!v) return;
      window.__BASE_PRICE_CENTS = v.price;
      applyEverywhere();
    });

    // When Shopify reloads sections (e.g., filtering grids), re-apply
    document.addEventListener('shopify:section:load', function () {
      applyEverywhere();
    });
  });
})();
